import { __styles, mergeClasses, tokens, typographyStyles } from '@fluentui/react-components';
export const sensitivityTooltipClassNames = {
  root: 'fai-SensitivityTooltip',
  heading: 'fai-SensitivityTooltip__heading',
  message: 'fai-SensitivityTooltip__message',
  previewSurface: 'fai-SensitivityTooltip__previewSurface',
  trigger: 'fai-SensitivityTooltip__trigger'
};
/**
 * Styles for the root slot
 */
const useStyles = __styles({
  root: {},
  heading: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "fy9rknc",
    Bhrd7zp: "flh3ekv",
    Bg96gwp: "fwrc4pm",
    sj55zd: "f19n0e5"
  },
  message: {},
  previewSurface: {
    B2u0y6b: "fwf794f"
  },
  trigger: {}
}, {
  d: [".fk6fouc{font-family:var(--fontFamilyBase);}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".flh3ekv{font-weight:var(--fontWeightBold);}", ".fwrc4pm{line-height:var(--lineHeightBase200);}", ".f19n0e5{color:var(--colorNeutralForeground1);}", ".fwf794f{max-width:293px;}"]
});
/**
 * Apply styling to the SensitivityTooltip slots based on the state
 */
export const useSensitivityTooltipStyles_unstable = state => {
  const styles = useStyles();
  state.root.className = mergeClasses(sensitivityTooltipClassNames.root, styles.root, state.root.className);
  if (state.heading) {
    state.heading.className = mergeClasses(sensitivityTooltipClassNames.heading, styles.heading, state.heading.className);
  }
  if (state.message) {
    state.message.className = mergeClasses(sensitivityTooltipClassNames.message, styles.message, state.message.className);
  }
  if (state.previewSurface) {
    state.previewSurface.className = mergeClasses(sensitivityTooltipClassNames.previewSurface, styles.previewSurface, state.previewSurface.className);
  }
  if (state.trigger) {
    state.trigger.className = mergeClasses(sensitivityTooltipClassNames.trigger, styles.trigger, state.trigger.className);
  }
  return state;
};
//# sourceMappingURL=useSensitivityTooltipStyles.js.map